/**
 * Interface représentant les paramètres de l'avance
 */
export class ParamAvance {
    actif: boolean;

    avanceHorsOM: boolean;

    calculPlafondAvance: boolean;

    idStatutAvanceAutomatique: number;

    imputationAvance: boolean;

    cloisonnementAvance: boolean;

    selectionComptable: boolean;

    montantModifiable: boolean;

    modeRapprochementDevise: number;

    idStatutAvancePartielle: number;

    reculDateOctroi: number;

    idStatutAvanceLettree: number;

    listeAvanceAutoFiltreFact: { id: string,libelle: string }[];

    listeAvanceAutoFiltreFP: { id: string,libelle: string }[];

    listeAvanceAutoFiltreIJ: { id: string,libelle: string }[];

    listeAvanceAuto: AvanceAuto[];

}

/**
 * Avance auto
 *
 * @author Lionel Gimenez
 * @date 11/06/2024
 */
export type AvanceAuto = {
    typeAvance: TypeAv;
    pourcentage: number;
}

/**
 * Enumération des types de l'avance liés à l'avance auto
 */
export enum TypeAv {
    INDEMN_JOURNALIERE = 0,
    FRAIS_PREV = 1,
    FACT_PREV = 2
}